import React, { useState, useContext, useId, useRef } from "react";

import { DataContext } from "../../../context/DataContext";
import { simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { addPuestosAsync } from "../../../api/Employees";
import { useAviso } from "../../../components/base";
import { ERROR_OTRA_SESION } from "../nomina/comunes";
import DialogoPuesto from "./DialogoPuesto";

const AgregarPuesto = ({ setShowModal, puestoReload, setPuestoReload }) => {
  const token = getToken();
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);
  const aviso = useAviso();
  const idTitulo = useId();
  const [description, setDescription] = useState("");
  const [errorDescripcion, setErrorDescripcion] = useState("");
  // El overlay de carga no bloquea el teclado (Enter): el ref corta un segundo envío al instante.
  const enviando = useRef(false);
  const [guardando, setGuardando] = useState(false);

  const cambiar = (valor) => {
    setDescription(valor);
    if (errorDescripcion) setErrorDescripcion("");
  };

  const saveChangesAsync = async () => {
    if (enviando.current) {
      return;
    }
    if (description.length === 0) {
      setErrorDescripcion("Ingrese el nombre del puesto");
      return;
    }

    enviando.current = true;
    setGuardando(true);
    setIsLoading(true);
    let result;
    try {
      result = await addPuestosAsync(token, description);
    } catch (e) {
      enviando.current = false;
      setGuardando(false);
      setIsLoading(false);
      aviso.error("No se pudo conectar con el servidor. Inténtalo de nuevo.");
      return;
    }
    enviando.current = false;
    setGuardando(false);
    if (!result.statusResponse) {
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      if (result.error === ERROR_OTRA_SESION) {
        simpleMessage(result.error, "error");
        return;
      }
      aviso.error(result.error || "No se pudo guardar el puesto");
      return;
    }

    setIsLoading(false);
    aviso.exito("Puesto agregado");
    setPuestoReload(!puestoReload);
    setShowModal(false);
  };

  return (
    <DialogoPuesto
      idTitulo={`${idTitulo}-titulo`}
      titulo="Agregar puesto"
      valor={description}
      onCambio={cambiar}
      error={errorDescripcion}
      guardando={guardando}
      sucio={description !== ""}
      onGuardar={saveChangesAsync}
      onCerrar={() => setShowModal(false)}
    />
  );
};

/**
 * Diálogo para agregar un puesto. Se dibuja solo si `abierto`: al cerrarlo y volver a abrirlo
 * empieza vacío.
 */
const AddPuesto = (props) => {
  if (props.abierto === false) return null;
  return <AgregarPuesto {...props} />;
};

export default AddPuesto;
